export enum OffcanvasPositionEnum {
    START = 'offcanvas-start',
    END = 'offcanvas-end',
    TOP = 'offcanvas-top',
    BOTTOM = 'offcanvas-bottom',
}
